export default __webpack_public_path__ + "static/media/logowide.32f50825.png";